import { Directive, ElementRef, Input, inject } from '@angular/core';

@Directive({
	selector: '[nhaTest]',
	standalone: true
})
export class NHATestDirective {
	private _el = inject(ElementRef);

	@Input('nhaTest') set selector(value: string) {
		this._selector = value;
		this.setTestAttribute();
	}

	private _selector: string;

	/** Inserted by Angular inject() migration for backwards compatibility */
	// eslint-disable-next-line @angular-eslint/prefer-inject
	constructor(...args: unknown[]);

	constructor() {}

	setTestAttribute(): void {
		const element: HTMLElement = <HTMLElement>this._el.nativeElement;
		if (this._selector !== undefined && this._selector.length > 0) {
			element.setAttribute('nha-test', this._selector);
			element.setAttribute('data-testid', this._selector);
			element.removeAttribute('nhatest');
		}
	}
}
